$("body").on("change", ".size_dropdown", function () {
  const selectedOption = $(this).find(":selected");
  const targetUrl = selectedOption.data("href");

  if (targetUrl) {
    window.location.href = targetUrl;
  }
});

if (document.querySelector('[data-fancybox="gallery"]')) {
  Fancybox.bind('[data-fancybox="gallery"]', {
    Thumbs: {
      type: "classic",
      showOnStart: false,
    },
  });
}
